/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminAssessments,
  AdminMinistry,
  AdminResponsesSummary,
  AdminSetupBody,
  AdminStats,
  AdminTrainingCourseAnalytics,
  BundleCheckoutBody,
  BundleCheckoutResult,
  CreateCampaignBody,
  CreateSuggestionBody,
  CreateTipSessionBody,
  DeleteResult,
  ErrorResponse,
  GetAdminResponsesParams,
  GetMyMinistryResponsesParams,
  HealthStatus,
  Ministry,
  MinistryResponsesResult,
  SeriesCheckoutBody,
  SubmitSurveyBody,
  SubmitSurveyResult,
  Suggestion,
  SurveyCampaign,
  SurveyInfo,
  TipSessionResult,
  TrainingAsset,
  TrainingAssetInput,
  TrainingCourse,
  TrainingCourseInput,
  TrainingCourseSummary,
  TrainingCourseUpdate,
  TrainingLesson,
  TrainingLessonInput,
  TrainingLessonResponse,
  TrainingLessonResponseInput,
  TrainingLessonUpdate,
  TrainingPreferences,
  TrainingPreferencesInput,
  TrainingUpload,
  TrainingUploadInput,
  UpsertMinistryBody,
  VideoReview,
  VideoReviewInput,
  VideoReviewUpdate,
  VideoReviewUpload,
  VideoReviewUploadInput,
  VoteSuggestionBody
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyMinistryUrl = () => {




  return `/api/ministries/me`
}

/**
 * @summary Get the current pastor's ministry
 */
export const getMyMinistry = async ( options?: RequestInit): Promise<Ministry> => {

  return customFetch<Ministry>(getGetMyMinistryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyMinistryQueryKey = () => {
    return [
    `/api/ministries/me`
    ] as const;
    }


export const getGetMyMinistryQueryOptions = <TData = Awaited<ReturnType<typeof getMyMinistry>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMinistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyMinistryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMinistry>>> = ({ signal }) => getMyMinistry({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyMinistry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyMinistryQueryResult = NonNullable<Awaited<ReturnType<typeof getMyMinistry>>>
export type GetMyMinistryQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get the current pastor's ministry
 */

export function useGetMyMinistry<TData = Awaited<ReturnType<typeof getMyMinistry>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMinistry>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyMinistryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertMinistryUrl = () => {




  return `/api/ministries`
}

/**
 * @summary Create or update the current pastor's ministry
 */
export const upsertMinistry = async (upsertMinistryBody: UpsertMinistryBody, options?: RequestInit): Promise<Ministry> => {

  return customFetch<Ministry>(getUpsertMinistryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertMinistryBody)
  }
);}





export const getUpsertMinistryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMinistry>>, TError,{data: BodyType<UpsertMinistryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertMinistry>>, TError,{data: BodyType<UpsertMinistryBody>}, TContext> => {

const mutationKey = ['upsertMinistry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertMinistry>>, {data: BodyType<UpsertMinistryBody>}> = (props) => {
          const {data} = props ?? {};

          return  upsertMinistry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertMinistryMutationResult = NonNullable<Awaited<ReturnType<typeof upsertMinistry>>>
    export type UpsertMinistryMutationBody = BodyType<UpsertMinistryBody>
    export type UpsertMinistryMutationError = ErrorType<unknown>

    /**
 * @summary Create or update the current pastor's ministry
 */
export const useUpsertMinistry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMinistry>>, TError,{data: BodyType<UpsertMinistryBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertMinistry>>,
        TError,
        {data: BodyType<UpsertMinistryBody>},
        TContext
      > => {
      return useMutation(getUpsertMinistryMutationOptions(options));
    }

export const getGetMyMinistryResponsesUrl = (params?: GetMyMinistryResponsesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ministries/me/responses?${stringifiedParams}` : `/api/ministries/me/responses`
}

/**
 * @summary Get all survey responses for the current pastor's ministry
 */
export const getMyMinistryResponses = async (params?: GetMyMinistryResponsesParams, options?: RequestInit): Promise<MinistryResponsesResult> => {

  return customFetch<MinistryResponsesResult>(getGetMyMinistryResponsesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyMinistryResponsesQueryKey = (params?: GetMyMinistryResponsesParams,) => {
    return [
    `/api/ministries/me/responses`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyMinistryResponsesQueryOptions = <TData = Awaited<ReturnType<typeof getMyMinistryResponses>>, TError = ErrorType<unknown>>(params?: GetMyMinistryResponsesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMinistryResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyMinistryResponsesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMinistryResponses>>> = ({ signal }) => getMyMinistryResponses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyMinistryResponses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyMinistryResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyMinistryResponses>>>
export type GetMyMinistryResponsesQueryError = ErrorType<unknown>


/**
 * @summary Get all survey responses for the current pastor's ministry
 */

export function useGetMyMinistryResponses<TData = Awaited<ReturnType<typeof getMyMinistryResponses>>, TError = ErrorType<unknown>>(
 params?: GetMyMinistryResponsesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMinistryResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyMinistryResponsesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyCampaignsUrl = () => {




  return `/api/ministries/me/campaigns`
}

/**
 * @summary List all survey campaigns for the current pastor's ministry
 */
export const getMyCampaigns = async ( options?: RequestInit): Promise<SurveyCampaign[]> => {

  return customFetch<SurveyCampaign[]>(getGetMyCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyCampaignsQueryKey = () => {
    return [
    `/api/ministries/me/campaigns`
    ] as const;
    }


export const getGetMyCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof getMyCampaigns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCampaigns>>> = ({ signal }) => getMyCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCampaigns>>>
export type GetMyCampaignsQueryError = ErrorType<unknown>


/**
 * @summary List all survey campaigns for the current pastor's ministry
 */

export function useGetMyCampaigns<TData = Awaited<ReturnType<typeof getMyCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyCampaignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCampaignUrl = () => {




  return `/api/ministries/me/campaigns`
}

/**
 * @summary Create a new survey campaign
 */
export const createCampaign = async (createCampaignBody: CreateCampaignBody, options?: RequestInit): Promise<SurveyCampaign> => {

  return customFetch<SurveyCampaign>(getCreateCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCampaignBody)
  }
);}





export const getCreateCampaignMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CreateCampaignBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CreateCampaignBody>}, TContext> => {

const mutationKey = ['createCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCampaign>>, {data: BodyType<CreateCampaignBody>}> = (props) => {
          const {data} = props ?? {};

          return  createCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createCampaign>>>
    export type CreateCampaignMutationBody = BodyType<CreateCampaignBody>
    export type CreateCampaignMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a new survey campaign
 */
export const useCreateCampaign = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaign>>, TError,{data: BodyType<CreateCampaignBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCampaign>>,
        TError,
        {data: BodyType<CreateCampaignBody>},
        TContext
      > => {
      return useMutation(getCreateCampaignMutationOptions(options));
    }

export const getDeleteCampaignUrl = (id: number,) => {




  return `/api/ministries/me/campaigns/${id}`
}

/**
 * @summary Delete a survey campaign
 */
export const deleteCampaign = async (id: number, options?: RequestInit): Promise<DeleteResult> => {

  return customFetch<DeleteResult>(getDeleteCampaignUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCampaignMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCampaign>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCampaign(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCampaign>>>

    export type DeleteCampaignMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a survey campaign
 */
export const useDeleteCampaign = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCampaign>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCampaignMutationOptions(options));
    }

export const getGetSurveyInfoUrl = (code: string,) => {




  return `/api/survey/${code}`
}

/**
 * @summary Get ministry info for the student survey
 */
export const getSurveyInfo = async (code: string, options?: RequestInit): Promise<SurveyInfo> => {

  return customFetch<SurveyInfo>(getGetSurveyInfoUrl(code),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSurveyInfoQueryKey = (code: string,) => {
    return [
    `/api/survey/${code}`
    ] as const;
    }


export const getGetSurveyInfoQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyInfo>>, TError = ErrorType<ErrorResponse>>(code: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSurveyInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyInfoQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyInfo>>> = ({ signal }) => getSurveyInfo(code, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSurveyInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyInfo>>>
export type GetSurveyInfoQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get ministry info for the student survey
 */

export function useGetSurveyInfo<TData = Awaited<ReturnType<typeof getSurveyInfo>>, TError = ErrorType<ErrorResponse>>(
 code: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSurveyInfo>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSurveyInfoQueryOptions(code,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitSurveyResponseUrl = (code: string,) => {




  return `/api/survey/${code}`
}

/**
 * @summary Submit an anonymous student survey response
 */
export const submitSurveyResponse = async (code: string,
    submitSurveyBody: SubmitSurveyBody, options?: RequestInit): Promise<SubmitSurveyResult> => {

  return customFetch<SubmitSurveyResult>(getSubmitSurveyResponseUrl(code),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitSurveyBody)
  }
);}





export const getSubmitSurveyResponseMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSurveyResponse>>, TError,{code: string;data: BodyType<SubmitSurveyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitSurveyResponse>>, TError,{code: string;data: BodyType<SubmitSurveyBody>}, TContext> => {

const mutationKey = ['submitSurveyResponse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitSurveyResponse>>, {code: string;data: BodyType<SubmitSurveyBody>}> = (props) => {
          const {code,data} = props ?? {};

          return  submitSurveyResponse(code,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitSurveyResponseMutationResult = NonNullable<Awaited<ReturnType<typeof submitSurveyResponse>>>
    export type SubmitSurveyResponseMutationBody = BodyType<SubmitSurveyBody>
    export type SubmitSurveyResponseMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit an anonymous student survey response
 */
export const useSubmitSurveyResponse = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitSurveyResponse>>, TError,{code: string;data: BodyType<SubmitSurveyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitSurveyResponse>>,
        TError,
        {code: string;data: BodyType<SubmitSurveyBody>},
        TContext
      > => {
      return useMutation(getSubmitSurveyResponseMutationOptions(options));
    }

export const getGetAdminStatsUrl = () => {




  return `/api/admin/stats`
}

/**
 * @summary Overall platform stats (admin only)
 */
export const getAdminStats = async ( options?: RequestInit): Promise<AdminStats> => {

  return customFetch<AdminStats>(getGetAdminStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStatsQueryKey = () => {
    return [
    `/api/admin/stats`
    ] as const;
    }


export const getGetAdminStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStats>>> = ({ signal }) => getAdminStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStats>>>
export type GetAdminStatsQueryError = ErrorType<unknown>


/**
 * @summary Overall platform stats (admin only)
 */

export function useGetAdminStats<TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminMinistriesUrl = () => {




  return `/api/admin/ministries`
}

/**
 * @summary All ministries with their response counts (admin only)
 */
export const getAdminMinistries = async ( options?: RequestInit): Promise<AdminMinistry[]> => {

  return customFetch<AdminMinistry[]>(getGetAdminMinistriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMinistriesQueryKey = () => {
    return [
    `/api/admin/ministries`
    ] as const;
    }


export const getGetAdminMinistriesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMinistries>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminMinistries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMinistriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMinistries>>> = ({ signal }) => getAdminMinistries({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMinistries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminMinistriesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMinistries>>>
export type GetAdminMinistriesQueryError = ErrorType<unknown>


/**
 * @summary All ministries with their response counts (admin only)
 */

export function useGetAdminMinistries<TData = Awaited<ReturnType<typeof getAdminMinistries>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminMinistries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminMinistriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteAdminMinistryUrl = (id: number,) => {




  return `/api/admin/ministries/${id}`
}

/**
 * @summary Delete a ministry and its related data (admin only)
 */
export const deleteAdminMinistry = async (id: number, options?: RequestInit): Promise<DeleteResult> => {

  return customFetch<DeleteResult>(getDeleteAdminMinistryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAdminMinistryMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminMinistry>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminMinistry>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAdminMinistry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminMinistry>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminMinistry(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminMinistryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminMinistry>>>

    export type DeleteAdminMinistryMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a ministry and its related data (admin only)
 */
export const useDeleteAdminMinistry = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminMinistry>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminMinistry>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAdminMinistryMutationOptions(options));
    }

export const getGetAdminAssessmentsUrl = () => {




  return `/api/admin/assessments`
}

/**
 * @summary Aggregate anonymous leader self-assessment results (admin only)
 */
export const getAdminAssessments = async ( options?: RequestInit): Promise<AdminAssessments> => {

  return customFetch<AdminAssessments>(getGetAdminAssessmentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminAssessmentsQueryKey = () => {
    return [
    `/api/admin/assessments`
    ] as const;
    }


export const getGetAdminAssessmentsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAssessments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAssessmentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAssessments>>> = ({ signal }) => getAdminAssessments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAssessments>>>
export type GetAdminAssessmentsQueryError = ErrorType<unknown>


/**
 * @summary Aggregate anonymous leader self-assessment results (admin only)
 */

export function useGetAdminAssessments<TData = Awaited<ReturnType<typeof getAdminAssessments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAssessments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminAssessmentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminResponsesUrl = (params?: GetAdminResponsesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/responses?${stringifiedParams}` : `/api/admin/responses`
}

/**
 * @summary All responses with optional filters (admin only)
 */
export const getAdminResponses = async (params?: GetAdminResponsesParams, options?: RequestInit): Promise<AdminResponsesSummary> => {

  return customFetch<AdminResponsesSummary>(getGetAdminResponsesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminResponsesQueryKey = (params?: GetAdminResponsesParams,) => {
    return [
    `/api/admin/responses`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminResponsesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminResponses>>, TError = ErrorType<unknown>>(params?: GetAdminResponsesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminResponsesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminResponses>>> = ({ signal }) => getAdminResponses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminResponses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminResponses>>>
export type GetAdminResponsesQueryError = ErrorType<unknown>


/**
 * @summary All responses with optional filters (admin only)
 */

export function useGetAdminResponses<TData = Awaited<ReturnType<typeof getAdminResponses>>, TError = ErrorType<unknown>>(
 params?: GetAdminResponsesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminResponsesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSuggestionsUrl = () => {




  return `/api/suggestions`
}

/**
 * @summary List all suggestions with vote counts
 */
export const listSuggestions = async ( options?: RequestInit): Promise<Suggestion[]> => {

  return customFetch<Suggestion[]>(getListSuggestionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuggestionsQueryKey = () => {
    return [
    `/api/suggestions`
    ] as const;
    }


export const getListSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof listSuggestions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuggestionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuggestions>>> = ({ signal }) => listSuggestions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSuggestions>>>
export type ListSuggestionsQueryError = ErrorType<unknown>


/**
 * @summary List all suggestions with vote counts
 */

export function useListSuggestions<TData = Awaited<ReturnType<typeof listSuggestions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSuggestionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSuggestionUrl = () => {




  return `/api/suggestions`
}

/**
 * @summary Submit a new suggestion
 */
export const createSuggestion = async (createSuggestionBody: CreateSuggestionBody, options?: RequestInit): Promise<Suggestion> => {

  return customFetch<Suggestion>(getCreateSuggestionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSuggestionBody)
  }
);}





export const getCreateSuggestionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuggestion>>, TError,{data: BodyType<CreateSuggestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSuggestion>>, TError,{data: BodyType<CreateSuggestionBody>}, TContext> => {

const mutationKey = ['createSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSuggestion>>, {data: BodyType<CreateSuggestionBody>}> = (props) => {
          const {data} = props ?? {};

          return  createSuggestion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof createSuggestion>>>
    export type CreateSuggestionMutationBody = BodyType<CreateSuggestionBody>
    export type CreateSuggestionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit a new suggestion
 */
export const useCreateSuggestion = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuggestion>>, TError,{data: BodyType<CreateSuggestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSuggestion>>,
        TError,
        {data: BodyType<CreateSuggestionBody>},
        TContext
      > => {
      return useMutation(getCreateSuggestionMutationOptions(options));
    }

export const getVoteSuggestionUrl = (id: number,) => {




  return `/api/suggestions/${id}/vote`
}

/**
 * @summary Upvote or downvote a suggestion (toggle)
 */
export const voteSuggestion = async (id: number,
    voteSuggestionBody: VoteSuggestionBody, options?: RequestInit): Promise<Suggestion> => {

  return customFetch<Suggestion>(getVoteSuggestionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(voteSuggestionBody)
  }
);}





export const getVoteSuggestionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voteSuggestion>>, TError,{id: number;data: BodyType<VoteSuggestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof voteSuggestion>>, TError,{id: number;data: BodyType<VoteSuggestionBody>}, TContext> => {

const mutationKey = ['voteSuggestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof voteSuggestion>>, {id: number;data: BodyType<VoteSuggestionBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  voteSuggestion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VoteSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof voteSuggestion>>>
    export type VoteSuggestionMutationBody = BodyType<VoteSuggestionBody>
    export type VoteSuggestionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Upvote or downvote a suggestion (toggle)
 */
export const useVoteSuggestion = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voteSuggestion>>, TError,{id: number;data: BodyType<VoteSuggestionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof voteSuggestion>>,
        TError,
        {id: number;data: BodyType<VoteSuggestionBody>},
        TContext
      > => {
      return useMutation(getVoteSuggestionMutationOptions(options));
    }

export const getCreateBundleCheckoutUrl = () => {




  return `/api/bundle/checkout`
}

/**
 * @summary Create a Shopify draft order for a bundle and return a checkout URL
 */
export const createBundleCheckout = async (bundleCheckoutBody: BundleCheckoutBody, options?: RequestInit): Promise<BundleCheckoutResult> => {

  return customFetch<BundleCheckoutResult>(getCreateBundleCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bundleCheckoutBody)
  }
);}





export const getCreateBundleCheckoutMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBundleCheckout>>, TError,{data: BodyType<BundleCheckoutBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBundleCheckout>>, TError,{data: BodyType<BundleCheckoutBody>}, TContext> => {

const mutationKey = ['createBundleCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBundleCheckout>>, {data: BodyType<BundleCheckoutBody>}> = (props) => {
          const {data} = props ?? {};

          return  createBundleCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBundleCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createBundleCheckout>>>
    export type CreateBundleCheckoutMutationBody = BodyType<BundleCheckoutBody>
    export type CreateBundleCheckoutMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a Shopify draft order for a bundle and return a checkout URL
 */
export const useCreateBundleCheckout = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBundleCheckout>>, TError,{data: BodyType<BundleCheckoutBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createBundleCheckout>>,
        TError,
        {data: BodyType<BundleCheckoutBody>},
        TContext
      > => {
      return useMutation(getCreateBundleCheckoutMutationOptions(options));
    }

export const getCreateSeriesCheckoutUrl = () => {




  return `/api/series/checkout`
}

/**
 * @summary Create a Shopify draft order for a single series and return a checkout URL
 */
export const createSeriesCheckout = async (seriesCheckoutBody: SeriesCheckoutBody, options?: RequestInit): Promise<BundleCheckoutResult> => {

  return customFetch<BundleCheckoutResult>(getCreateSeriesCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(seriesCheckoutBody)
  }
);}





export const getCreateSeriesCheckoutMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSeriesCheckout>>, TError,{data: BodyType<SeriesCheckoutBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSeriesCheckout>>, TError,{data: BodyType<SeriesCheckoutBody>}, TContext> => {

const mutationKey = ['createSeriesCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSeriesCheckout>>, {data: BodyType<SeriesCheckoutBody>}> = (props) => {
          const {data} = props ?? {};

          return  createSeriesCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSeriesCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof createSeriesCheckout>>>
    export type CreateSeriesCheckoutMutationBody = BodyType<SeriesCheckoutBody>
    export type CreateSeriesCheckoutMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a Shopify draft order for a single series and return a checkout URL
 */
export const useCreateSeriesCheckout = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSeriesCheckout>>, TError,{data: BodyType<SeriesCheckoutBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSeriesCheckout>>,
        TError,
        {data: BodyType<SeriesCheckoutBody>},
        TContext
      > => {
      return useMutation(getCreateSeriesCheckoutMutationOptions(options));
    }

export const getCreateTipSessionUrl = () => {




  return `/api/stripe/tip`
}

/**
 * @summary Create a Stripe checkout session for a tip
 */
export const createTipSession = async (createTipSessionBody: CreateTipSessionBody, options?: RequestInit): Promise<TipSessionResult> => {

  return customFetch<TipSessionResult>(getCreateTipSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTipSessionBody)
  }
);}





export const getCreateTipSessionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTipSession>>, TError,{data: BodyType<CreateTipSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTipSession>>, TError,{data: BodyType<CreateTipSessionBody>}, TContext> => {

const mutationKey = ['createTipSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTipSession>>, {data: BodyType<CreateTipSessionBody>}> = (props) => {
          const {data} = props ?? {};

          return  createTipSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTipSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createTipSession>>>
    export type CreateTipSessionMutationBody = BodyType<CreateTipSessionBody>
    export type CreateTipSessionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a Stripe checkout session for a tip
 */
export const useCreateTipSession = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTipSession>>, TError,{data: BodyType<CreateTipSessionBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTipSession>>,
        TError,
        {data: BodyType<CreateTipSessionBody>},
        TContext
      > => {
      return useMutation(getCreateTipSessionMutationOptions(options));
    }

export const getSetupAdminUrl = () => {




  return `/api/admin/setup`
}

/**
 * @summary Elevate the current user to admin using a secret code
 */
export const setupAdmin = async (adminSetupBody: AdminSetupBody, options?: RequestInit): Promise<Ministry> => {

  return customFetch<Ministry>(getSetupAdminUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adminSetupBody)
  }
);}





export const getSetupAdminMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupAdmin>>, TError,{data: BodyType<AdminSetupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setupAdmin>>, TError,{data: BodyType<AdminSetupBody>}, TContext> => {

const mutationKey = ['setupAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setupAdmin>>, {data: BodyType<AdminSetupBody>}> = (props) => {
          const {data} = props ?? {};

          return  setupAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetupAdminMutationResult = NonNullable<Awaited<ReturnType<typeof setupAdmin>>>
    export type SetupAdminMutationBody = BodyType<AdminSetupBody>
    export type SetupAdminMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Elevate the current user to admin using a secret code
 */
export const useSetupAdmin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupAdmin>>, TError,{data: BodyType<AdminSetupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setupAdmin>>,
        TError,
        {data: BodyType<AdminSetupBody>},
        TContext
      > => {
      return useMutation(getSetupAdminMutationOptions(options));
    }

export const getListTrainingCoursesUrl = () => {




  return `/api/training/courses`
}

export const listTrainingCourses = async ( options?: RequestInit): Promise<TrainingCourse[]> => {

  return customFetch<TrainingCourse[]>(getListTrainingCoursesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTrainingCoursesQueryKey = () => {
    return [
    `/api/training/courses`
    ] as const;
    }


export const getListTrainingCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listTrainingCourses>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingCourses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTrainingCoursesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrainingCourses>>> = ({ signal }) => listTrainingCourses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTrainingCourses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTrainingCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listTrainingCourses>>>
export type ListTrainingCoursesQueryError = ErrorType<ErrorResponse>



export function useListTrainingCourses<TData = Awaited<ReturnType<typeof listTrainingCourses>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingCourses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTrainingCoursesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTrainingPreferencesUrl = () => {




  return `/api/training/preferences`
}

export const getTrainingPreferences = async ( options?: RequestInit): Promise<TrainingPreferences | null> => {

  return customFetch<TrainingPreferences | null>(getGetTrainingPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrainingPreferencesQueryKey = () => {
    return [
    `/api/training/preferences`
    ] as const;
    }


export const getGetTrainingPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getTrainingPreferences>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrainingPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrainingPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrainingPreferences>>> = ({ signal }) => getTrainingPreferences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrainingPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrainingPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getTrainingPreferences>>>
export type GetTrainingPreferencesQueryError = ErrorType<ErrorResponse>



export function useGetTrainingPreferences<TData = Awaited<ReturnType<typeof getTrainingPreferences>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrainingPreferences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTrainingPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveTrainingPreferencesUrl = () => {




  return `/api/training/preferences`
}

export const saveTrainingPreferences = async (trainingPreferencesInput: TrainingPreferencesInput, options?: RequestInit): Promise<TrainingPreferences> => {

  return customFetch<TrainingPreferences>(getSaveTrainingPreferencesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingPreferencesInput)
  }
);}





export const getSaveTrainingPreferencesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTrainingPreferences>>, TError,{data: BodyType<TrainingPreferencesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveTrainingPreferences>>, TError,{data: BodyType<TrainingPreferencesInput>}, TContext> => {

const mutationKey = ['saveTrainingPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveTrainingPreferences>>, {data: BodyType<TrainingPreferencesInput>}> = (props) => {
          const {data} = props ?? {};

          return  saveTrainingPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveTrainingPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof saveTrainingPreferences>>>
    export type SaveTrainingPreferencesMutationBody = BodyType<TrainingPreferencesInput>
    export type SaveTrainingPreferencesMutationError = ErrorType<unknown>

    export const useSaveTrainingPreferences = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTrainingPreferences>>, TError,{data: BodyType<TrainingPreferencesInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveTrainingPreferences>>,
        TError,
        {data: BodyType<TrainingPreferencesInput>},
        TContext
      > => {
      return useMutation(getSaveTrainingPreferencesMutationOptions(options));
    }

export const getListTrainingResponsesUrl = (courseId: number,) => {




  return `/api/training/courses/${courseId}/responses`
}

export const listTrainingResponses = async (courseId: number, options?: RequestInit): Promise<TrainingLessonResponse[]> => {

  return customFetch<TrainingLessonResponse[]>(getListTrainingResponsesUrl(courseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTrainingResponsesQueryKey = (courseId: number,) => {
    return [
    `/api/training/courses/${courseId}/responses`
    ] as const;
    }


export const getListTrainingResponsesQueryOptions = <TData = Awaited<ReturnType<typeof listTrainingResponses>>, TError = ErrorType<ErrorResponse>>(courseId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTrainingResponsesQueryKey(courseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrainingResponses>>> = ({ signal }) => listTrainingResponses(courseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: courseId !== null && courseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTrainingResponses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTrainingResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof listTrainingResponses>>>
export type ListTrainingResponsesQueryError = ErrorType<ErrorResponse>



export function useListTrainingResponses<TData = Awaited<ReturnType<typeof listTrainingResponses>>, TError = ErrorType<ErrorResponse>>(
 courseId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTrainingResponsesQueryOptions(courseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveTrainingLessonResponseUrl = (lessonId: number,) => {




  return `/api/training/lessons/${lessonId}/responses`
}

export const saveTrainingLessonResponse = async (lessonId: number,
    trainingLessonResponseInput: TrainingLessonResponseInput, options?: RequestInit): Promise<TrainingLessonResponse> => {

  return customFetch<TrainingLessonResponse>(getSaveTrainingLessonResponseUrl(lessonId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingLessonResponseInput)
  }
);}





export const getSaveTrainingLessonResponseMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTrainingLessonResponse>>, TError,{lessonId: number;data: BodyType<TrainingLessonResponseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveTrainingLessonResponse>>, TError,{lessonId: number;data: BodyType<TrainingLessonResponseInput>}, TContext> => {

const mutationKey = ['saveTrainingLessonResponse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveTrainingLessonResponse>>, {lessonId: number;data: BodyType<TrainingLessonResponseInput>}> = (props) => {
          const {lessonId,data} = props ?? {};

          return  saveTrainingLessonResponse(lessonId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveTrainingLessonResponseMutationResult = NonNullable<Awaited<ReturnType<typeof saveTrainingLessonResponse>>>
    export type SaveTrainingLessonResponseMutationBody = BodyType<TrainingLessonResponseInput>
    export type SaveTrainingLessonResponseMutationError = ErrorType<ErrorResponse>

    export const useSaveTrainingLessonResponse = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTrainingLessonResponse>>, TError,{lessonId: number;data: BodyType<TrainingLessonResponseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveTrainingLessonResponse>>,
        TError,
        {lessonId: number;data: BodyType<TrainingLessonResponseInput>},
        TContext
      > => {
      return useMutation(getSaveTrainingLessonResponseMutationOptions(options));
    }

export const getListTrainingCourseSummariesUrl = () => {




  return `/api/training/course-summaries`
}

/**
 * @summary List published training course summaries for marketing pages
 */
export const listTrainingCourseSummaries = async ( options?: RequestInit): Promise<TrainingCourseSummary[]> => {

  return customFetch<TrainingCourseSummary[]>(getListTrainingCourseSummariesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTrainingCourseSummariesQueryKey = () => {
    return [
    `/api/training/course-summaries`
    ] as const;
    }


export const getListTrainingCourseSummariesQueryOptions = <TData = Awaited<ReturnType<typeof listTrainingCourseSummaries>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingCourseSummaries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTrainingCourseSummariesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrainingCourseSummaries>>> = ({ signal }) => listTrainingCourseSummaries({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTrainingCourseSummaries>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTrainingCourseSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof listTrainingCourseSummaries>>>
export type ListTrainingCourseSummariesQueryError = ErrorType<unknown>


/**
 * @summary List published training course summaries for marketing pages
 */

export function useListTrainingCourseSummaries<TData = Awaited<ReturnType<typeof listTrainingCourseSummaries>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTrainingCourseSummaries>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTrainingCourseSummariesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAdminTrainingCoursesUrl = () => {




  return `/api/admin/training/courses`
}

export const listAdminTrainingCourses = async ( options?: RequestInit): Promise<TrainingCourse[]> => {

  return customFetch<TrainingCourse[]>(getListAdminTrainingCoursesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminTrainingCoursesQueryKey = () => {
    return [
    `/api/admin/training/courses`
    ] as const;
    }


export const getListAdminTrainingCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminTrainingCourses>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminTrainingCourses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminTrainingCoursesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminTrainingCourses>>> = ({ signal }) => listAdminTrainingCourses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminTrainingCourses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminTrainingCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminTrainingCourses>>>
export type ListAdminTrainingCoursesQueryError = ErrorType<unknown>



export function useListAdminTrainingCourses<TData = Awaited<ReturnType<typeof listAdminTrainingCourses>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminTrainingCourses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminTrainingCoursesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTrainingCourseUrl = () => {




  return `/api/admin/training/courses`
}

export const createTrainingCourse = async (trainingCourseInput: TrainingCourseInput, options?: RequestInit): Promise<TrainingCourse> => {

  return customFetch<TrainingCourse>(getCreateTrainingCourseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingCourseInput)
  }
);}





export const getCreateTrainingCourseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingCourse>>, TError,{data: BodyType<TrainingCourseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTrainingCourse>>, TError,{data: BodyType<TrainingCourseInput>}, TContext> => {

const mutationKey = ['createTrainingCourse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrainingCourse>>, {data: BodyType<TrainingCourseInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTrainingCourse(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrainingCourseMutationResult = NonNullable<Awaited<ReturnType<typeof createTrainingCourse>>>
    export type CreateTrainingCourseMutationBody = BodyType<TrainingCourseInput>
    export type CreateTrainingCourseMutationError = ErrorType<unknown>

    export const useCreateTrainingCourse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingCourse>>, TError,{data: BodyType<TrainingCourseInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTrainingCourse>>,
        TError,
        {data: BodyType<TrainingCourseInput>},
        TContext
      > => {
      return useMutation(getCreateTrainingCourseMutationOptions(options));
    }

export const getGetAdminTrainingAnalyticsUrl = () => {




  return `/api/admin/training/analytics`
}

/**
 * @summary User counts and completion rates for published training courses
 */
export const getAdminTrainingAnalytics = async ( options?: RequestInit): Promise<AdminTrainingCourseAnalytics[]> => {

  return customFetch<AdminTrainingCourseAnalytics[]>(getGetAdminTrainingAnalyticsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminTrainingAnalyticsQueryKey = () => {
    return [
    `/api/admin/training/analytics`
    ] as const;
    }


export const getGetAdminTrainingAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTrainingAnalytics>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTrainingAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTrainingAnalyticsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTrainingAnalytics>>> = ({ signal }) => getAdminTrainingAnalytics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTrainingAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminTrainingAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTrainingAnalytics>>>
export type GetAdminTrainingAnalyticsQueryError = ErrorType<ErrorResponse>


/**
 * @summary User counts and completion rates for published training courses
 */

export function useGetAdminTrainingAnalytics<TData = Awaited<ReturnType<typeof getAdminTrainingAnalytics>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTrainingAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminTrainingAnalyticsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTrainingCourseUrl = (id: number,) => {




  return `/api/admin/training/courses/${id}`
}

export const updateTrainingCourse = async (id: number,
    trainingCourseUpdate: TrainingCourseUpdate, options?: RequestInit): Promise<TrainingCourse> => {

  return customFetch<TrainingCourse>(getUpdateTrainingCourseUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingCourseUpdate)
  }
);}





export const getUpdateTrainingCourseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingCourse>>, TError,{id: number;data: BodyType<TrainingCourseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTrainingCourse>>, TError,{id: number;data: BodyType<TrainingCourseUpdate>}, TContext> => {

const mutationKey = ['updateTrainingCourse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTrainingCourse>>, {id: number;data: BodyType<TrainingCourseUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTrainingCourse(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTrainingCourseMutationResult = NonNullable<Awaited<ReturnType<typeof updateTrainingCourse>>>
    export type UpdateTrainingCourseMutationBody = BodyType<TrainingCourseUpdate>
    export type UpdateTrainingCourseMutationError = ErrorType<unknown>

    export const useUpdateTrainingCourse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingCourse>>, TError,{id: number;data: BodyType<TrainingCourseUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTrainingCourse>>,
        TError,
        {id: number;data: BodyType<TrainingCourseUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTrainingCourseMutationOptions(options));
    }

export const getDeleteTrainingCourseUrl = (id: number,) => {




  return `/api/admin/training/courses/${id}`
}

export const deleteTrainingCourse = async (id: number, options?: RequestInit): Promise<DeleteResult> => {

  return customFetch<DeleteResult>(getDeleteTrainingCourseUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTrainingCourseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingCourse>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingCourse>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTrainingCourse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrainingCourse>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTrainingCourse(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrainingCourseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrainingCourse>>>

    export type DeleteTrainingCourseMutationError = ErrorType<unknown>

    export const useDeleteTrainingCourse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingCourse>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrainingCourse>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTrainingCourseMutationOptions(options));
    }

export const getPublishAllTrainingCourseContentUrl = (id: number,) => {




  return `/api/admin/training/courses/${id}/publish-all`
}

/**
 * @summary Publish a course and every lesson in it
 */
export const publishAllTrainingCourseContent = async (id: number, options?: RequestInit): Promise<TrainingCourse> => {

  return customFetch<TrainingCourse>(getPublishAllTrainingCourseContentUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishAllTrainingCourseContentMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAllTrainingCourseContent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishAllTrainingCourseContent>>, TError,{id: number}, TContext> => {

const mutationKey = ['publishAllTrainingCourseContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishAllTrainingCourseContent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  publishAllTrainingCourseContent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishAllTrainingCourseContentMutationResult = NonNullable<Awaited<ReturnType<typeof publishAllTrainingCourseContent>>>

    export type PublishAllTrainingCourseContentMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Publish a course and every lesson in it
 */
export const usePublishAllTrainingCourseContent = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAllTrainingCourseContent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishAllTrainingCourseContent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPublishAllTrainingCourseContentMutationOptions(options));
    }

export const getCreateTrainingLessonUrl = (courseId: number,) => {




  return `/api/admin/training/courses/${courseId}/lessons`
}

export const createTrainingLesson = async (courseId: number,
    trainingLessonInput: TrainingLessonInput, options?: RequestInit): Promise<TrainingLesson> => {

  return customFetch<TrainingLesson>(getCreateTrainingLessonUrl(courseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingLessonInput)
  }
);}





export const getCreateTrainingLessonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingLesson>>, TError,{courseId: number;data: BodyType<TrainingLessonInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTrainingLesson>>, TError,{courseId: number;data: BodyType<TrainingLessonInput>}, TContext> => {

const mutationKey = ['createTrainingLesson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrainingLesson>>, {courseId: number;data: BodyType<TrainingLessonInput>}> = (props) => {
          const {courseId,data} = props ?? {};

          return  createTrainingLesson(courseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrainingLessonMutationResult = NonNullable<Awaited<ReturnType<typeof createTrainingLesson>>>
    export type CreateTrainingLessonMutationBody = BodyType<TrainingLessonInput>
    export type CreateTrainingLessonMutationError = ErrorType<unknown>

    export const useCreateTrainingLesson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingLesson>>, TError,{courseId: number;data: BodyType<TrainingLessonInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTrainingLesson>>,
        TError,
        {courseId: number;data: BodyType<TrainingLessonInput>},
        TContext
      > => {
      return useMutation(getCreateTrainingLessonMutationOptions(options));
    }

export const getUpdateTrainingLessonUrl = (id: number,) => {




  return `/api/admin/training/lessons/${id}`
}

export const updateTrainingLesson = async (id: number,
    trainingLessonUpdate: TrainingLessonUpdate, options?: RequestInit): Promise<TrainingLesson> => {

  return customFetch<TrainingLesson>(getUpdateTrainingLessonUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingLessonUpdate)
  }
);}





export const getUpdateTrainingLessonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingLesson>>, TError,{id: number;data: BodyType<TrainingLessonUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTrainingLesson>>, TError,{id: number;data: BodyType<TrainingLessonUpdate>}, TContext> => {

const mutationKey = ['updateTrainingLesson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTrainingLesson>>, {id: number;data: BodyType<TrainingLessonUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTrainingLesson(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTrainingLessonMutationResult = NonNullable<Awaited<ReturnType<typeof updateTrainingLesson>>>
    export type UpdateTrainingLessonMutationBody = BodyType<TrainingLessonUpdate>
    export type UpdateTrainingLessonMutationError = ErrorType<unknown>

    export const useUpdateTrainingLesson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrainingLesson>>, TError,{id: number;data: BodyType<TrainingLessonUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTrainingLesson>>,
        TError,
        {id: number;data: BodyType<TrainingLessonUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTrainingLessonMutationOptions(options));
    }

export const getDeleteTrainingLessonUrl = (id: number,) => {




  return `/api/admin/training/lessons/${id}`
}

export const deleteTrainingLesson = async (id: number, options?: RequestInit): Promise<DeleteResult> => {

  return customFetch<DeleteResult>(getDeleteTrainingLessonUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTrainingLessonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingLesson>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingLesson>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTrainingLesson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrainingLesson>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTrainingLesson(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrainingLessonMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrainingLesson>>>

    export type DeleteTrainingLessonMutationError = ErrorType<unknown>

    export const useDeleteTrainingLesson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingLesson>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrainingLesson>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTrainingLessonMutationOptions(options));
    }

export const getCreateTrainingUploadUrl = () => {




  return `/api/admin/training/upload-url`
}

export const createTrainingUpload = async (trainingUploadInput: TrainingUploadInput, options?: RequestInit): Promise<TrainingUpload> => {

  return customFetch<TrainingUpload>(getCreateTrainingUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingUploadInput)
  }
);}





export const getCreateTrainingUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingUpload>>, TError,{data: BodyType<TrainingUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTrainingUpload>>, TError,{data: BodyType<TrainingUploadInput>}, TContext> => {

const mutationKey = ['createTrainingUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrainingUpload>>, {data: BodyType<TrainingUploadInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTrainingUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrainingUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createTrainingUpload>>>
    export type CreateTrainingUploadMutationBody = BodyType<TrainingUploadInput>
    export type CreateTrainingUploadMutationError = ErrorType<unknown>

    export const useCreateTrainingUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingUpload>>, TError,{data: BodyType<TrainingUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTrainingUpload>>,
        TError,
        {data: BodyType<TrainingUploadInput>},
        TContext
      > => {
      return useMutation(getCreateTrainingUploadMutationOptions(options));
    }

export const getCreateTrainingAssetUrl = (lessonId: number,) => {




  return `/api/admin/training/lessons/${lessonId}/assets`
}

export const createTrainingAsset = async (lessonId: number,
    trainingAssetInput: TrainingAssetInput, options?: RequestInit): Promise<TrainingAsset> => {

  return customFetch<TrainingAsset>(getCreateTrainingAssetUrl(lessonId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(trainingAssetInput)
  }
);}





export const getCreateTrainingAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingAsset>>, TError,{lessonId: number;data: BodyType<TrainingAssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTrainingAsset>>, TError,{lessonId: number;data: BodyType<TrainingAssetInput>}, TContext> => {

const mutationKey = ['createTrainingAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrainingAsset>>, {lessonId: number;data: BodyType<TrainingAssetInput>}> = (props) => {
          const {lessonId,data} = props ?? {};

          return  createTrainingAsset(lessonId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrainingAssetMutationResult = NonNullable<Awaited<ReturnType<typeof createTrainingAsset>>>
    export type CreateTrainingAssetMutationBody = BodyType<TrainingAssetInput>
    export type CreateTrainingAssetMutationError = ErrorType<unknown>

    export const useCreateTrainingAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrainingAsset>>, TError,{lessonId: number;data: BodyType<TrainingAssetInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTrainingAsset>>,
        TError,
        {lessonId: number;data: BodyType<TrainingAssetInput>},
        TContext
      > => {
      return useMutation(getCreateTrainingAssetMutationOptions(options));
    }

export const getDeleteTrainingAssetUrl = (id: number,) => {




  return `/api/admin/training/assets/${id}`
}

export const deleteTrainingAsset = async (id: number, options?: RequestInit): Promise<DeleteResult> => {

  return customFetch<DeleteResult>(getDeleteTrainingAssetUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTrainingAssetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingAsset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingAsset>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTrainingAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTrainingAsset>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTrainingAsset(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTrainingAssetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTrainingAsset>>>

    export type DeleteTrainingAssetMutationError = ErrorType<unknown>

    export const useDeleteTrainingAsset = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTrainingAsset>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTrainingAsset>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTrainingAssetMutationOptions(options));
    }

export const getDownloadTrainingAssetUrl = (id: number,) => {




  return `/api/training/assets/${id}/download`
}

export const downloadTrainingAsset = async (id: number, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getDownloadTrainingAssetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadTrainingAssetQueryKey = (id: number,) => {
    return [
    `/api/training/assets/${id}/download`
    ] as const;
    }


export const getDownloadTrainingAssetQueryOptions = <TData = Awaited<ReturnType<typeof downloadTrainingAsset>>, TError = ErrorType<void | ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadTrainingAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadTrainingAssetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadTrainingAsset>>> = ({ signal }) => downloadTrainingAsset(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadTrainingAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadTrainingAssetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadTrainingAsset>>>
export type DownloadTrainingAssetQueryError = ErrorType<void | ErrorResponse>



export function useDownloadTrainingAsset<TData = Awaited<ReturnType<typeof downloadTrainingAsset>>, TError = ErrorType<void | ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadTrainingAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadTrainingAssetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListVideoReviewsUrl = () => {




  return `/api/video-reviews`
}

/**
 * @summary List published video reviews
 */
export const listVideoReviews = async ( options?: RequestInit): Promise<VideoReview[]> => {

  return customFetch<VideoReview[]>(getListVideoReviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVideoReviewsQueryKey = () => {
    return [
    `/api/video-reviews`
    ] as const;
    }


export const getListVideoReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listVideoReviews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVideoReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVideoReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVideoReviews>>> = ({ signal }) => listVideoReviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVideoReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVideoReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listVideoReviews>>>
export type ListVideoReviewsQueryError = ErrorType<unknown>


/**
 * @summary List published video reviews
 */

export function useListVideoReviews<TData = Awaited<ReturnType<typeof listVideoReviews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVideoReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVideoReviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDownloadVideoReviewMediaUrl = (fileName: string,) => {




  return `/api/video-reviews/media/${fileName}`
}

/**
 * @summary Stream video review media with byte-range support
 */
export const downloadVideoReviewMedia = async (fileName: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getDownloadVideoReviewMediaUrl(fileName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadVideoReviewMediaQueryKey = (fileName: string,) => {
    return [
    `/api/video-reviews/media/${fileName}`
    ] as const;
    }


export const getDownloadVideoReviewMediaQueryOptions = <TData = Awaited<ReturnType<typeof downloadVideoReviewMedia>>, TError = ErrorType<ErrorResponse>>(fileName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadVideoReviewMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadVideoReviewMediaQueryKey(fileName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadVideoReviewMedia>>> = ({ signal }) => downloadVideoReviewMedia(fileName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: fileName !== null && fileName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadVideoReviewMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadVideoReviewMediaQueryResult = NonNullable<Awaited<ReturnType<typeof downloadVideoReviewMedia>>>
export type DownloadVideoReviewMediaQueryError = ErrorType<ErrorResponse>


/**
 * @summary Stream video review media with byte-range support
 */

export function useDownloadVideoReviewMedia<TData = Awaited<ReturnType<typeof downloadVideoReviewMedia>>, TError = ErrorType<ErrorResponse>>(
 fileName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadVideoReviewMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadVideoReviewMediaQueryOptions(fileName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAdminVideoReviewsUrl = () => {




  return `/api/admin/video-reviews`
}

/**
 * @summary List all video reviews for management
 */
export const listAdminVideoReviews = async ( options?: RequestInit): Promise<VideoReview[]> => {

  return customFetch<VideoReview[]>(getListAdminVideoReviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminVideoReviewsQueryKey = () => {
    return [
    `/api/admin/video-reviews`
    ] as const;
    }


export const getListAdminVideoReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminVideoReviews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminVideoReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminVideoReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminVideoReviews>>> = ({ signal }) => listAdminVideoReviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminVideoReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminVideoReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminVideoReviews>>>
export type ListAdminVideoReviewsQueryError = ErrorType<unknown>


/**
 * @summary List all video reviews for management
 */

export function useListAdminVideoReviews<TData = Awaited<ReturnType<typeof listAdminVideoReviews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminVideoReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminVideoReviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateVideoReviewUrl = () => {




  return `/api/admin/video-reviews`
}

/**
 * @summary Create a video review
 */
export const createVideoReview = async (videoReviewInput: VideoReviewInput, options?: RequestInit): Promise<VideoReview> => {

  return customFetch<VideoReview>(getCreateVideoReviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(videoReviewInput)
  }
);}





export const getCreateVideoReviewMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoReview>>, TError,{data: BodyType<VideoReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVideoReview>>, TError,{data: BodyType<VideoReviewInput>}, TContext> => {

const mutationKey = ['createVideoReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVideoReview>>, {data: BodyType<VideoReviewInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVideoReview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVideoReviewMutationResult = NonNullable<Awaited<ReturnType<typeof createVideoReview>>>
    export type CreateVideoReviewMutationBody = BodyType<VideoReviewInput>
    export type CreateVideoReviewMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a video review
 */
export const useCreateVideoReview = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoReview>>, TError,{data: BodyType<VideoReviewInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVideoReview>>,
        TError,
        {data: BodyType<VideoReviewInput>},
        TContext
      > => {
      return useMutation(getCreateVideoReviewMutationOptions(options));
    }

export const getCreateVideoReviewUploadUrl = () => {




  return `/api/admin/video-reviews/upload-url`
}

/**
 * @summary Create an admin-only direct upload URL for review media
 */
export const createVideoReviewUpload = async (videoReviewUploadInput: VideoReviewUploadInput, options?: RequestInit): Promise<VideoReviewUpload> => {

  return customFetch<VideoReviewUpload>(getCreateVideoReviewUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(videoReviewUploadInput)
  }
);}





export const getCreateVideoReviewUploadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoReviewUpload>>, TError,{data: BodyType<VideoReviewUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVideoReviewUpload>>, TError,{data: BodyType<VideoReviewUploadInput>}, TContext> => {

const mutationKey = ['createVideoReviewUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVideoReviewUpload>>, {data: BodyType<VideoReviewUploadInput>}> = (props) => {
          const {data} = props ?? {};

          return  createVideoReviewUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVideoReviewUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createVideoReviewUpload>>>
    export type CreateVideoReviewUploadMutationBody = BodyType<VideoReviewUploadInput>
    export type CreateVideoReviewUploadMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create an admin-only direct upload URL for review media
 */
export const useCreateVideoReviewUpload = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoReviewUpload>>, TError,{data: BodyType<VideoReviewUploadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVideoReviewUpload>>,
        TError,
        {data: BodyType<VideoReviewUploadInput>},
        TContext
      > => {
      return useMutation(getCreateVideoReviewUploadMutationOptions(options));
    }

export const getUpdateVideoReviewUrl = (id: number,) => {




  return `/api/admin/video-reviews/${id}`
}

/**
 * @summary Update a video review
 */
export const updateVideoReview = async (id: number,
    videoReviewUpdate: VideoReviewUpdate, options?: RequestInit): Promise<VideoReview> => {

  return customFetch<VideoReview>(getUpdateVideoReviewUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(videoReviewUpdate)
  }
);}





export const getUpdateVideoReviewMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideoReview>>, TError,{id: number;data: BodyType<VideoReviewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVideoReview>>, TError,{id: number;data: BodyType<VideoReviewUpdate>}, TContext> => {

const mutationKey = ['updateVideoReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVideoReview>>, {id: number;data: BodyType<VideoReviewUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVideoReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVideoReviewMutationResult = NonNullable<Awaited<ReturnType<typeof updateVideoReview>>>
    export type UpdateVideoReviewMutationBody = BodyType<VideoReviewUpdate>
    export type UpdateVideoReviewMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a video review
 */
export const useUpdateVideoReview = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideoReview>>, TError,{id: number;data: BodyType<VideoReviewUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVideoReview>>,
        TError,
        {id: number;data: BodyType<VideoReviewUpdate>},
        TContext
      > => {
      return useMutation(getUpdateVideoReviewMutationOptions(options));
    }

export const getDeleteVideoReviewUrl = (id: number,) => {




  return `/api/admin/video-reviews/${id}`
}

/**
 * @summary Delete a video review and its media
 */
export const deleteVideoReview = async (id: number, options?: RequestInit): Promise<DeleteResult> => {

  return customFetch<DeleteResult>(getDeleteVideoReviewUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteVideoReviewMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideoReview>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVideoReview>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteVideoReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVideoReview>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteVideoReview(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVideoReviewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVideoReview>>>

    export type DeleteVideoReviewMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a video review and its media
 */
export const useDeleteVideoReview = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideoReview>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVideoReview>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteVideoReviewMutationOptions(options));
    }

